import Chat from "../../components/ChatChamadoBonus";
import Header from "../../components/Header";
import Finalizacao from "../../components/Modais/FinalizacaoModal";
import Quadrinhos from "../../components/Quadrinhos";
import CodeRain from '../../components/CodeRain'
import DefaultModal from '../../components/Modais/DefaultModal'
import icone_XP from '../../assets/imagens/icone_XP.png'

import {API_URL} from '../../config/api'
import {useState, useRef, useEffect} from 'react'
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import {motion} from 'motion/react'


export default function ChamadoBonus(){
    const [showChat, setChat] = useState(true)
    const [showAgradecimento, setShowAgradecimento] = useState(false)
    const [animarMoeda, setAnimarMoeda] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [scoreBonus, setScoreBonus] = useState(null)

    const navigate = useNavigate()

    const {user, setScore} = useAuth()
    const token = localStorage.getItem("token")


 

    const [destino, setDestino] = useState({
        x: 0,
        y: 0
    });

    const moedaRef = useRef(null);

   if (!user || !token) {
        return <Navigate to="/login" replace />;
    }


    const seguir = () =>{
        setChat(false)
    }

    const handleFecharModal = async () => {
        setShowAgradecimento(false)

        const result = await ganhaPontos()

        if (result.scoreBonus) {
            setScoreBonus(result.scoreBonus)
            setScore(result.scoreTotal)
            setShowModal(true)
        }
    }

    const ganhaPontos = async () => {
        try {
            const response = await fetch(
                `${API_URL}/user/chamado-bonus/${user.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            )

            if (!response.ok) {
                const erro = await response.text()
                throw new Error(erro)
            }

            const data = await response.json()

            console.log("Bônus recebido:", data)

            return data

        } catch (error) {
            console.error("Erro na requisição:", error.message)
            return null
        }
    }
    //ANIMAÇÃO DA MOEDA
    const handleSeguir = async () => {
        const audio = new Audio('/sounds/moeda.mp3')
        audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))

        const moeda = moedaRef.current;

        const caixaXP = document
            .getElementById("xp-box");

        const posicaoMoeda = moeda.getBoundingClientRect();

        const posicaoCaixaXP = caixaXP.getBoundingClientRect();


        const x =
            posicaoCaixaXP.left -
            posicaoMoeda.left;


        const y =
            posicaoCaixaXP.top -
            posicaoMoeda.top;


        setDestino({
            x: x,
            y: y
        });
        setAnimarMoeda(true);

        setTimeout(()=>{
            navigate('/inicial')
        },1000)
       
    };
    

    return ( 
        <>
            <Header/>
            <CodeRain />
            <section className="containerDefault">
                {showChat && <Chat seguir={seguir}/>}
                {!showChat && <Quadrinhos setShowModal={setShowAgradecimento} />}

                <Finalizacao showModal={showAgradecimento} closeModal={handleFecharModal} />

            </section>

            <DefaultModal modalIsOpen={showModal} closeModal={() => handleSeguir() } sound='positive'>

                <h1> Parabéns por concluir</h1>

                <p>  Você Recebeu: </p>


                <div id="scoreRecebido" className="flex">
                    <motion.img
                        ref={moedaRef}
                        src={icone_XP}
                        width={40}
                        height={40}
                        initial={{
                            x: 0,
                            y: 0,
                            opacity: 1,
                            scale: 1
                        }}
                        animate={
                            animarMoeda
                                ? {
                                    x: destino.x,
                                    y: destino.y,
                                    opacity: 0,
                                    scale: 0.5
                                }
                                : {
                                    x: 0,
                                    y: 0,
                                    opacity: 1,
                                    scale: 1
                                }
                        }


                        transition={{
                            duration: 0.8,
                            ease: "easeInOut"
                        }}
                        onAnimationComplete={() => {
                            console.log("Animação terminou: ", animarMoeda)
                           if(animarMoeda){
                            navigate("/inicial")
                           }
                        }}

                    />
                    <p className="numero scoreRecebido">{scoreBonus} </p>

                </div>

            </DefaultModal>


        </>
    )
}